/** SprintFit Shopify — full catalog collection. */
export const SPRINTFIT_COLLECTIONS_URL = 'https://www.sprintfit.in/collections/all';

/** ThermaCube on the live Shopify storefront (matches published product page). */
export const THERMACUBE_CHECKOUT_URL =
  'https://www.sprintfit.in/products/thermacube-hot-cold-therapy-device';

/**
 * Backend proxy for Shopify products.json (Shopify does not send CORS headers for this URL).
 * With CRA dev proxy, `/api/...` forwards to the FastAPI server on port 8000.
 */
export function getSprintfitProductsApiUrl() {
  const base = process.env.REACT_APP_BACKEND_URL?.replace(/\/$/, '');
  if (base) return `${base}/api/sprintfit-products`;
  return '/api/sprintfit-products';
}
